<template>
    <div class="modal-card view-contact-modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ heading }}</p>
        </header>

        <section class="modal-card-body">
            <o-table
                class="is-responsive is-responsive-desktop"
                detailed
                :data="userBilling"
                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="false"
                :loading="table.loading"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :per-page="table.perPage"
                :pagination-simple="table.paginationSimple"
                :selected.sync="selected"
                :checked-rows="checkedRows"
                @update:checkedRows="$event => checkedRows = $event"
            >
                <template>

                    <o-table-column #default="{ row }" field="title" label="Title" sortable>
                        {{ row.title }}
                    </o-table-column>

<!--                    <o-table-column field="description" label="Description" sortable v-html="row.description" />-->

<!--                  <o-table-column #default="{ row }">-->
<!--                    <quill-editor style="pointer-events: none;opacity: 0.6;" content-type="html" :content="row.description" :disable="true"/>-->
<!--                  </o-table-column>-->

                    <o-table-column #default="{ row }" field="price" label="Price" sortable>
                        {{$filters.currency(row.final_price) }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="project_id" label="Project" sortable>
                        <router-link :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                            {{$filters.valueOrDefault(projectNameById(row.project_id)) }}
                        </router-link>
                    </o-table-column>

                    <o-table-column #default="{ row }" field="billed_at" label="Billed At" sortable>
                        {{$filters.datetime(row.billed_at) }}
                    </o-table-column>

                </template>

              <template #detail="{ row }">
                <div class="columns">
                  <div class="column">
                    <div class="field">
                      <label class="label">Description</label>
                      <div class="control" style="pointer-events: none;opacity: 0.6;">
                        <quill-editor  content-type="html" :content="row.description"/>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template #empty>
                <div class="has-text-centered">
                  This table is empty!
                </div>
              </template>
            </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Table from './../../mixins/Table'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
      components: {QuillEditor},
      mixins: [Table],

        props: ['userBilling', 'heading'],

        computed: {
            ...mapGetters({
                userNameById: 'userNameById',
                projectNameById: 'projectNameById'
            })
        }
    }
</script>
<style scoped>
.control div.ql-toolbar{
  display: none !important;
}
</style>
